export default {"src":"/_next/static/media/ship-schools-text-only-dark.799474ef.svg","height":16,"width":79,"blurWidth":0,"blurHeight":0};